import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { catchError } from "@_utils/helpers";

import { Button, Paper, makeStyles } from "@material-ui/core";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import { userActions } from "@_actions/user.actions";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import styles from "./ChangeName.module.css";

function ChangeName({
  userEmail,
  userName,
  publicName,
  setProfileName,
  setDisplayChangeName,
}) {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userReducer);
  const useStyles = makeStyles({
    helperText: { fontSize: "12px !important" },

    confirmButton: {
      fontWeight: "bold !important",
      color: "var(--color-theme-blue) !important",
      border: "1px solid var(--color-theme-blue) !important",

      "&:hover": {
        color: "var(--color-theme-white) !important",
        backgroundColor: "var(--color-theme-blue) !important",
        boxShadow: "2px 6px 6px  #0000002",
      },
    },
    cancelButton: {
      fontWeight: "bold !important",
      color: "var(--color-theme-silver) !important",
      border: "1px solid var(--color-theme-silver) !important",
      "&:hover": {
        color: "var(--color-theme-white) !important",
        backgroundColor: "var(--color-theme-silver) !important",
        boxShadow: "2px 6px 6px  #0000002",
      },
    },
  });
  const classes = useStyles();
  const [nameObj, setNameObj] = useState({
    name: userName,
    public_name: publicName,
  });

  const [errors, setErrors] = useState({
    name: false,
    public_name: false,
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    let username = nameObj.name && nameObj.name.trim();
    let publicName = nameObj.public_name && nameObj.public_name.trim();

    let newErrors = {
      name: !username,
      public_name: !publicName,
      message: "",
    };

    if (!username || !publicName) {
      newErrors.message = "Please enter valid values for all fields";
      setErrors(newErrors);
      return;
    }

    setProfileName(username, publicName);
    dispatch(
      userActions.resetName({ name: username, public_name: publicName })
    );
  };

  useEffect(() => {
    setProfileName(userName);
  }, [userName, setProfileName]);

  useEffect(() => {
    if (userState.status.USER_RESET_NAME === "success") {
      setSuccessMessage(true);
      setTimeout(() => {
        dispatch(userActions.clearStatusMessage("USER_RESET_NAME"));
        const user = {
          email: userEmail,
          accessToken: userState.user_access_token,
        };
        localStorage.setItem("user", JSON.stringify(user));
        setDisplayChangeName(false);
      }, 2000);
    } else if (catchError(userState.status.USER_RESET_NAME)) {
      setErrors({
        name: true,
        public_name: true,
        message: userState.status.USER_RESET_NAME,
      });
    }
    // eslint-disable-next-line
  }, [userState.status, setDisplayChangeName, dispatch]);

  const handleClickAway = () => {
    setDisplayChangeName(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Paper className={styles.container}>
        <p className={styles.changeNameHeader}>Your Profile</p>
        <p className={styles.email}>{userEmail}</p>
        <TextfieldInput
          name="name"
          label="Your Name"
          value={nameObj.name}
          onChange={(e) => {
            setNameObj({ ...nameObj, [e.target.name]: e.target.value });
            setErrors({ ...errors, name: false, message: "" });
          }}
          error={errors.name}
          helperText={errors.name && errors.message}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
          required
        />

        <TextfieldInput
          name="public_name"
          label="Public Name"
          placeholder="Public Name"
          value={nameObj.public_name}
          onChange={(e) => {
            setNameObj({ ...nameObj, [e.target.name]: e.target.value });
            setErrors({ ...errors, public_name: false, message: "" });
          }}
          error={errors.public_name}
          helperText={errors.public_name && errors.message}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
          required
        />
        <div className={styles.button_container}>
          <Button
            className={classes.cancelButton}
            onClick={() => {
              setDisplayChangeName(false);
            }}
          >
            Cancel
          </Button>
          <Button className={classes.confirmButton} onClick={handleSubmit}>
            Save
          </Button>
        </div>
        {successMessage && (
          <div className={styles.succsse_message}>
            <CheckCircleIcon />
            You have successfully changed your name
          </div>
        )}
      </Paper>
    </ClickAwayListener>
  );
}
export default ChangeName;
